module.exports = __webpack_public_path__ + "static/media/hero-screen.c00b08cc.png";